import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          autoplay: true,
          controls: false,
          loop: true,
          src: `${config.ASSETS_URL}/01/12/principle/he-air/45deg.m4v`,
        },
      },
      styles: { padding: "1.01% 18.188%" },
    },
  },
];

export default components;
